export enum TaskListHeadlineModel {
  CONFIRMED_COMPLETE = "Archive",
  DECLARED_COMPLETE = "Ready for Sign-off",
  WORK_IN_PROCESS = "Work in Process",
  QUEUED = "Queued",
  PENDING = "New tasks pending approval"
}